import { useState } from 'react';
import { Link } from 'react-router-dom';
import { tenantPortalAPI } from '../lib/api';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { toast } from 'sonner';
import { KeyRound, Loader2, ArrowLeft, CheckCircle2 } from 'lucide-react';

export default function MieterPasswortVergessen() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await tenantPortalAPI.forgotPassword({ email });
      setSubmitted(true);
    } catch (error) {
      toast.error('Etwas ist schiefgelaufen, bitte später erneut versuchen.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <Card className="w-full max-w-md border-slate-200 shadow-lg" data-testid="forgot-password-card">
        <CardHeader className="text-center pb-2">
          <div className="flex justify-center mb-4">
            <div className="w-14 h-14 bg-emerald-100 rounded-xl flex items-center justify-center">
              {submitted ? (
                <CheckCircle2 className="w-8 h-8 text-emerald-600" />
              ) : (
                <KeyRound className="w-8 h-8 text-emerald-600" />
              )}
            </div>
          </div>
          <CardTitle className="text-2xl" style={{ fontFamily: 'Manrope, sans-serif' }}>
            {submitted ? 'E-Mail unterwegs' : 'Passwort vergessen?'}
          </CardTitle>
          <CardDescription>
            {submitted
              ? 'Falls die E-Mail im System hinterlegt ist, haben wir Ihnen einen Link zum Zurücksetzen geschickt.'
              : 'Geben Sie Ihre E-Mail-Adresse ein – wir senden Ihnen einen Link zum Zurücksetzen.'}
          </CardDescription>
        </CardHeader>
        <CardContent>
          {submitted ? (
            <div className="space-y-4">
              <div className="text-sm text-slate-600 bg-slate-50 border border-slate-200 rounded-lg p-4">
                <p>Bitte prüfen Sie auch Ihren Spam-Ordner. Der Link ist <strong>60 Minuten</strong> gültig.</p>
              </div>
              <Link to="/mieter/login" className="block">
                <Button variant="outline" className="w-full" data-testid="back-to-login-button">
                  <ArrowLeft className="h-4 w-4 mr-2" />
                  Zurück zum Login
                </Button>
              </Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="email">E-Mail</Label>
                <Input
                  id="email"
                  type="email"
                  data-testid="forgot-email-input"
                  placeholder="ihre@email.de"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <Button
                type="submit"
                className="w-full bg-slate-900 hover:bg-slate-800"
                data-testid="forgot-submit-button"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                    Senden...
                  </>
                ) : (
                  'Reset-Link anfordern'
                )}
              </Button>
              <Link to="/mieter/login" className="block text-center text-sm text-slate-500 hover:text-slate-900">
                Zurück zum Login
              </Link>
            </form>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
